



















import AppHeader from '~/components/car/header/AppHeader.vue'
import { PARKING_NS, ParkingState } from '~/store/modules/shared/parking/state'
import AppFooter from '~/components/car/footer/AppFooter.vue'
import LanguageSwitcher from '~/services/LanguageSwitcher'
import {
  computed,
  defineComponent,
  defineVue3AsyncComponent,
  onBeforeMount,
  onMounted,
  ref,
  useFetch,
  useRoute,
  watch
} from '~/utils/nuxt3-migration'
import AppBottomMenu from '~/components/car/header/AppBottomMenu.vue'
import { useDeps } from '~/compositions/dependency-container'
import AdmanAdsService from '~/services/ads/AdmanAdsService'
import FlashService from '~/services/flash/FlashService'
import { useGlobalElements } from '~/compositions/global-elements'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import { PAGE_NS, PageState } from '~/store/modules/shared/page/state'
import AppNotifications from '~/components/shared/configurable/notification-center/AppNotifications.vue'
import AppSnackbar from '~/components/car/AppSnackbar.vue'

export default defineComponent({
  components: {
    AppSnackbar,
    AppNotifications,
    AppBottomMenu,
    AppFooter,
    AppHeader,
    ParkingModal: defineVue3AsyncComponent(() =>
      import('~/components/shared/parking/ParkingModal.vue')
    )
  },
  setup() {
    const route = useRoute()
    const {
      isIframe,
      showMobileBottomMenu,
      isSubdomain,
      showParking,
      showFooter,
      showHeader,
      isLoginModalVisible
    } = useGlobalElements()

    const [languageSwitcherService, admanAdsService, flashService] = useDeps(
      LanguageSwitcher,
      AdmanAdsService,
      FlashService
    )

    const { state: classifiedSearchState } = useNamespacedStore<SearchState>(
      CLASSIFIED_SEARCH_NS
    )
    const { dispatch: pageDispatch } = useNamespacedStore<PageState>(PAGE_NS)
    const { dispatch: parkingDispatch } = useNamespacedStore<ParkingState>(
      PARKING_NS
    )

    const availableLocales = ref(languageSwitcherService.getAvailableLocales())

    useFetch(() => {
      if (isIframe.value) {
        pageDispatch('addBodyClass', 'iframe')
      }
      if (isSubdomain.value) {
        pageDispatch('addBodyClass', 'subdomain')
      }
    })

    const currentRoute = computed(() => classifiedSearchState.currentRoute)

    onBeforeMount(() => {
      flashService.setClientFlashFromCookie()
    })

    onMounted(() => {
      window.history.scrollRestoration = 'auto'
    })

    watch(currentRoute, val => {
      availableLocales.value = languageSwitcherService.getAvailableLocales(val)
    })

    watch(route, val => {
      availableLocales.value = languageSwitcherService.getAvailableLocales()
      if (process.client) {
        admanAdsService.refreshInnovativeFormats(val)
      }
    })

    function hideParkingModal() {
      parkingDispatch('hideParking')
    }

    return {
      currentRoute,
      showParking,
      availableLocales,
      isIframe,
      isSubdomain,
      hideParkingModal,
      showFooter,
      showHeader,
      isLoginModalVisible,
      showMobileBottomMenu
    }
  },
  head() {
    const { bodyClasses } = this.$store.state.page
    return {
      bodyAttrs: {
        class: bodyClasses.join(' ')
      }
    }
  }
})
